import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import Logo from "./Logo";

interface NavbarProps {
  toggle: () => void;
  hasBottomBorder?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ toggle, hasBottomBorder = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-40 ${
        isScrolled ? "bg-white border-b border-gray-200" : "bg-transparent"
      }`}
      style={{
        transition: "background-color 300ms ease-in-out",
      }}
    >
      <div className="container mx-auto md:px-48 px-6 py-2 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          {/* Logo Component */}
          <Logo
            size={isScrolled ? 100 : 150} // Logo size changes based on scroll
            style={{
              transition: "all 300ms ease-in-out", // Smooth transition for resizing
            }}
          />
          <div
            className={`text-xl font-bold ${
              isScrolled ? "text-gray-800" : "text-white"
            }`}
            style={{
              transition: "color 300ms ease-in-out",
            }}
          ></div>
        </div>
        <div className="flex items-center">
          <button
            onClick={toggle}
            className={`lg:hidden focus:outline-none text-xl font-bold ${
              isScrolled ? "text-gray-800" : "text-white"
            }`}
          >
            <GiHamburgerMenu size={28} />
          </button>
          <ul
            className="hidden lg:flex space-x-8 text-xl"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            {[
              { to: "/", text: "Hem" },
              { to: "/boka", text: "Boka" },
              { to: "/schema", text: "Schema" },
              { to: "/klasser", text: "Klasser" },
              { to: "/massage", text: "Massage" },
              { to: "/omoss", text: "Om oss" },
              { to: "/kontakt", text: "Kontakt" },
            ].map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`${
                    isScrolled ? "text-anotherGray" : "text-white"
                  } hover:text-hoverGray`}
                  style={{
                    transition: "color 300ms ease-in-out",
                  }}
                >
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
